import React from 'react'
import PropTypes from 'prop-types'
import IconComponent from '../button/IconComponent'

const InputComponent = ({
  style,
  input_style,
  input_icon,
  label,
  type,
  placeholder,
  name,
  value,
  onChange,
  onKeyDown,
  required,
  hidden,
  disabled,
  display,
}) => {
  if (hidden) return null; // If hidden is true, skip rendering the input
  return (
    <>
      {display
        ?
        <div className={`${style}`} >
          {label !== "" &&
            <label htmlFor={name} className="form-label" >
              {required && <span className="text-danger"> * </span>}{label}
            </label>
          }
          {input_icon ?
            <div className="input-group">
              <IconComponent icon={input_icon} color="#1e88e5" inputStyle="icon" />
              <input
                className={`${input_style}`}
                type={type}
                placeholder={placeholder ? placeholder : `Enter ${label}`}
                name={name}
                value={value}
                onChange={onChange}
                onKeyDown={onKeyDown}
                required={required}
                disabled={disabled}
              />
            </div>
            :
            <input
              className={`${input_style}`}
              type={type}
              placeholder={placeholder ? placeholder : `Enter ${label}`}
              name={name}
              value={value}
              onChange={onChange}
              onKeyDown={onKeyDown}
              required={required}
              disabled={disabled}
            />
          }
        </div>
        :
        <div className={`${style}`} >
          <div className="flex">
            {label !== "" &&
              <div className={`col-md-3`} >
                <label
                  className="form-label"
                  htmlFor={name}
                >
                  {required && <span className="text-danger"> * </span>}{label}
                </label>
              </div>
            }
            <div className={`col-md-9`} >
              {input_icon ?
                <div className="input-group">
                  <IconComponent icon={input_icon} color="#1e88e5" inputStyle="icon" />
                  <input
                    className={`${input_style}`}
                    type={type}
                    placeholder={placeholder ? placeholder : `Enter ${label}`}
                    name={name}
                    value={value}
                    onChange={onChange}
                    onKeyDown={onKeyDown}
                    required={required}
                    disabled={disabled}
                  />
                </div>
                :
                <input
                  className={`${input_style}`}
                  type={type}
                  placeholder={placeholder ? placeholder : `Enter ${label}`}
                  name={name}
                  value={value}
                  onChange={onChange}
                  onKeyDown={onKeyDown}
                  required={required}
                  disabled={disabled}
                />
              }
            </div>
          </div>
        </div>
      }
    </>
  )
}

InputComponent.propTypes = {
  style: PropTypes.string,
  input_style: PropTypes.string,
  input_icon: PropTypes.string,
  label: PropTypes.string,
  type: PropTypes.string,
  placeholder: PropTypes.string,
  name: PropTypes.string.isRequired,
  value: PropTypes.any,
  onChange: PropTypes.func.isRequired,
  onKeyDown: PropTypes.func,
  required: PropTypes.bool,
  hidden: PropTypes.bool,
  disabled: PropTypes.bool,
  display: PropTypes.bool,
}

export default InputComponent
